// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Info_wrapper__2uzG2","content":"Info_content__xU2cF","title":"Info_title__3_Q01","list":"Info_list__1SWHV","with_padding":"Info_with_padding__3PCv8"};